import store from "../storeWire";
import { setStateToRedux } from "../store/slice/system";
import { useSelector } from "react-redux";

function internal(data, name, dontSetInitialValue = false) {
    let value = useSelector((state) => state.entities.system.stateToRedux[name]);

    const setState = newState => {
        store.dispatch(setStateToRedux({
            data: newState,
            name
        }));
    };

    if (value === undefined) {
        if (!dontSetInitialValue) {
            setState(data);
        }
        value = data;
    }

    return [value, setState, name];
}

function useReduxState(data, name = 'COMPONENT', dontSetInitialValue = false) {
    return internal(data, name, dontSetInitialValue)
}

export default useReduxState;